import SwiperSlider, { SwiperSlide } from "../../components/swiper";

const HomeImageSlider = ({ bgColor, color, data, swiperKey, disabledSlider }) => {

  const settings = {
    loop: true,
    spaceBetween: 15,
    navigation: disabledSlider ? false : true,
    autoplay: disabledSlider ? false : true,
    allowTouchMove: disabledSlider ? false : true,
    simulateTouch: disabledSlider ? false : true,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
      },
    },

  };

  const imageSliderSettings = {
    loop: false,
    spaceBetween: 15,
    navigation: disabledSlider ? false : true,
    autoplay: disabledSlider ? false : true,
    allowTouchMove: disabledSlider ? false : true,
    simulateTouch: disabledSlider ? false : true,
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  };

  return (
    <section
      className="home_image_slider_section"
      style={{ backgroundColor: bgColor, color: color }}
    >
      <SwiperSlider
        key={swiperKey}
        className="container"
        options={settings}
        showArrows={false}
        navClass={`main_slider_${swiperKey}`}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="heading_top">
              <h4
                className="heading_with_line center_aligned"
                style={{ color: color }}
              >
                {item.secondaryTitle}
              </h4>
              <h2 className="section_main_heading" style={{ color: color }}>
                {item.title}
              </h2>
              <p style={{ color: color }}>{item.desc}</p>
            </div>
            <SwiperSlider
              className="slider_images"
              options={imageSliderSettings}
              showArrows={false}
              navClass={`image_slider_${swiperKey}`}
            >
              {item.images.map((img, i) => (
                <SwiperSlide key={i}>
                  <img src={img} alt={`slide-${index}-img-${i}`} style={{ width: "100%", height: "380px", objectFit: "cover" }} />
                </SwiperSlide>
              ))}
            </SwiperSlider>
          </SwiperSlide>
        ))}
      </SwiperSlider>
    </section>
  );
};

export default HomeImageSlider;
